import useAuth from "@features/auth/hooks/useAuth";

import getAnonymousRequestUid from "@/utils/getAnonymousRequestUid";
import getSearchEngineUser from "@/utils/getSearchEngineUser";

/**
 * @deprecated
 */
export default function getSearchEngineUserUid(): string {
  if (typeof window === "undefined") {
    return getSearchEngineUser();
  }

  try {
    const { user } = useAuth();
    const userId = user?.uid;

    return userId ?? getAnonymousRequestUid();
  } catch (error) {
    console.error("Error in getSearchEngineUserUid:", error);
    return getSearchEngineUser();
  }
}
